// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3XQZv","body":"Modal_body__2FG1Z","icon":"Modal_icon__2V3vP","title":"Modal_title__3HmHY","desc":"Modal_desc__367f3","btn":"Modal_btn__3R0nn"};